// Constants for different requests for current reducer
export default {
  CLIENT_EMAIL_SETTINGS: 'CLIENT_EMAIL_SETTINGS',
  DISABLE_CLIENT_EMAIL_SETTING: 'DISABLE_CLIENT_EMAIL_SETTING',
  ENABLE_CLIENT_EMAIL_SETTING: 'ENABLE_CLIENT_EMAIL_SETTING',
  CLIENT_EMAIL_RECIPIENTS: 'CLIENT_EMAIL_RECIPIENTS',
  UPDATE_CLIENT_EMAIL_RECIPIENTS: 'UPDATE_CLIENT_EMAIL_RECIPIENTS',
};
